import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import utils from '../../utils/utils';
import DATE_FORMAT from '../../components/constants/dateFormat';
import PackerRouteRow from './packerRouteRow';
import { useRoutes } from './apiHooks';
import Helmet from 'react-helmet';

const PackerRoutesIndex = ({ match }) => {
  const {
    routes,
    isFetching,
    isLoading: loading,
    isError,
    error,
  } = useRoutes({
    customPackingType: match.params.customPackingType,
    deliveryDayId: match.params.deliveryDayId,
    version: 2,
    showOrderInfo: !!match.params.customPackingType,
  });

  const sortedRoutes = routes
    ? routes.sort((a, b) =>
        utils.getDateFromString(a.deliveryFrom).isBefore(utils.getDateFromString(b.deliveryFrom)) ? -1 : 1
      )
    : [];
  const groupedRoutes = utils.groupBy(sortedRoutes, 'deliveryFrom');
  const { formatMessage } = useIntl();

  return (
    <>
      <Helmet>
        <title>{formatMessage({ id: 'packer.routes.title' })}</title>
      </Helmet>
      <Loader show={loading || isFetching} />
      {isError ? <ErrorMessage error={utils.getErrorMessageFromResponse(error)} /> : ''}

      <div className="m-b-6">
        <h2>
          <FormattedMessage id={'packer.routes.title'} />
        </h2>
        {routes ? (
          <div>
            <FormattedMessage id={'packer.routes.amount'} values={{ amount: routes.length }} />
          </div>
        ) : (
          ''
        )}
      </div>
      {Object.keys(groupedRoutes).map((key, index) => {
        const routes = groupedRoutes[key];

        return (
          <div key={index}>
            <h3>{utils.getFormattedDateFromString(key, DATE_FORMAT.onlyTime)}</h3>
            <div className="m-b-3">
              <FormattedMessage id={'packer.routes.time.range.amount'} values={{ amount: routes.length }} />
            </div>

            <div className="row">
              {routes.map((route) => (
                <div key={route.id} className="col-12 col-lg-7">
                  <PackerRouteRow
                    route={route}
                    deliveryDayId={match.params.deliveryDayId}
                    customPackingType={match.params.customPackingType}
                  />
                </div>
              ))}
            </div>
            <hr className="m-t-3 m-b-6" />
          </div>
        );
      })}
    </>
  );
};

PackerRoutesIndex.propTypes = {};

PackerRoutesIndex.defaultProps = {};

export default PackerRoutesIndex;
